<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,11.379999940395356C13.77,14.109999940395355,11.03,15.999999940395355,7.85,15.999999940395355C3.51,15.999999940395355,0,12.489999940395355,0,8.149999940395356C0,4.969999940395356,1.89,2.229999940395355,4.62,0.9999999403953552C4.17,1.9899999403953552,3.92,3.0799999403953553,3.92,4.229999940395356C3.92,8.559999940395354,7.43,12.079999940395355,11.77,12.079999940395355C12.92,12.079999940395355,14.01,11.829999940395355,15,11.379999940395356C15,11.379999940395356,15,11.379999940395356,15,11.379999940395356Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Moon',
} as DefineComponent
</script>
